import React, { useState } from "react";
import { Form, Input, Select, DatePicker, Button, Space, Row, Col } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;
const { Option } = Select;

const ActionItemFilter = ({ onSearch, onReset }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSearch = async () => {
        try {
            setLoading(true);
            const values = await form.validateFields();
            onSearch(values);
        } catch (error) {
            console.error("搜索参数验证失败:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    return (
        <Form
            form={form}
            layout="vertical"
            initialValues={{
                status: ["PENDING_AI", "PENDING_REVIEW", "PROCESSING"], // 默认选中待处理状态
            }}
        >
            <Row gutter={16}>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item label="搜索关键词" name="search_key">
                        <Input placeholder="搜索内容、来源ID、AI备注等" allowClear />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item label="处理状态" name="status">
                        <Select
                            mode="multiple"
                            placeholder="选择状态"
                            allowClear
                            options={[
                                { label: "待AI处理", value: "PENDING_AI" },
                                { label: "待人工审核", value: "PENDING_REVIEW" },
                                { label: "处理中", value: "PROCESSING" },
                                { label: "已完成", value: "COMPLETED" },
                                { label: "处理失败", value: "FAILED" },
                                { label: "已拒绝", value: "REJECTED" },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item label="优先级" name="priority">
                        <Select placeholder="选择优先级" allowClear>
                            <Option value={1}>高</Option>
                            <Option value={2}>中</Option>
                            <Option value={3}>低</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item label="来源类型" name="source_type">
                        <Select
                            placeholder="选择来源类型"
                            allowClear
                            options={[
                                { label: "航班消息MVT", value: "FLIGHT_MESSAGE_MVT" },
                                { label: "航班消息其他", value: "FLIGHT_MESSAGE_OTHER" },
                                { label: "系统航班冲突告警", value: "SYSTEM_FLIGHT_CONFLICT_ALERT" },
                                { label: "邮件处理", value: "EMAIL_PROCESSING" },
                                { label: "用户请求", value: "USER_REQUEST" },
                                { label: "系统自动", value: "SYSTEM_AUTO" },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item label="Agent类型" name="agent_type">
                        <Select
                            placeholder="选择Agent类型"
                            allowClear
                            options={[
                                { label: "MVT处理Agent", value: "MVT_PROCESSING_AGENT_V2" },
                                { label: "航食Agent", value: "CATERING_AGENT" },
                                { label: "许可申请Agent", value: "PERMIT_REQUEST_AGENT" },
                                { label: "通用处理Agent", value: "GENERAL_PROCESSING_AGENT" },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item label="创建时间" name="dateRange">
                        <RangePicker style={{ width: "100%" }} showTime format="YYYY-MM-DD HH:mm:ss" />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Space>
                        <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch} loading={loading}>
                            搜索
                        </Button>
                        <Button icon={<ReloadOutlined />} onClick={handleReset}>
                            重置
                        </Button>
                    </Space>
                </Col>
            </Row>
        </Form>
    );
};

export default ActionItemFilter;
